import { t } from "components/CentralDataMangement/translation/Translation";
import AutoCompleteDropdown from "components/common/atoms/AutoCompleteDropdown";
import CheckBoxField from "components/common/atoms/CheckBoxField";
import LabelField from "components/common/atoms/LabelField";
import RadioField from "components/common/atoms/RadioField";
import SelectWithSearch from "components/common/atoms/SelectWithSearch";
import { LabelWithInputField } from "components/common/molecules/LabelWithInputField";
import LabelWithTextAreaField from "components/common/molecules/LabelWithTextAreaField";
import PhoneInputWithCountrySelect from "react-phone-number-input";
import PhoneInput from "react-phone-number-input";
import type { RootState } from "store";
export const FormElements = (
  field: any,
  handleChange: any,
  formData: any,
  errors: any,
  formName: string,
  disableField: Object[],
  authUser: RootState
) => {
  const { type, value } = field;
  switch (type) {
    case "text":
    case "string":
      return (
        <div
          className={value.className ? value.className : "col-sm-12 col-md-6"}
        >
          <LabelWithInputField
            label={t(value.label)}
            name={value.name}
            id={field.name}
            type={value.fieldtype ?? "text"}
            placeholder={t(value.placeholder)}
            handleChange={handleChange}
            isMandatory={value.required}
            value={formData[value.name] ?? ""}
            error={errors[value.name]}
            {...(value?.showForMiles
              ? {
                  isDisabled:
                    authUser.email !== "absolute-jobs-team@infanion.com",
                }
              : { isDisabled: value.isDisabled ?? false })}
          />
        </div>
      );
    case "number":
      return (
        <div
          className={value.className ? value.className : "col-sm-12 col-md-6 "}
        >
          <LabelWithInputField
            label={t(value.label)}
            name={value.name}
            id={field.name}
            type={value.fieldtype ?? "number"}
            placeholder={t(value.placeholder)}
            handleChange={handleChange}
            isMandatory={value.required}
            value={formData[value.name] ?? ""}
            error={errors[value.name]}
            {...(value?.showForMiles
              ? {
                  isDisabled:
                    authUser.email !== "absolute-jobs-team@infanion.com",
                }
              : { isDisabled: value.isDisabled ?? false })}
          />
        </div>
      );
    case "multi-select":
      return (
        <div
          className={value.className ? value.className : "col-sm-12 col-md-6"}
        >
          <SelectWithSearch
            search={value.search}
            onChange={handleChange}
            title={value.label}
            options={field.value.options}
            placeHolder={t("Select")}
            isMulti={value.isMultiSelect}
            name={value.name}
            isMandatory={value.required}
            isDisabled={disableField.includes(value.name)}
            error={errors[value.name]}
            id={field.name}
            value={formData[value.name]}
          />
        </div>
      );
    case "mobile-number":
      return (
        <div
          className={value.className ? value.className : "col-sm-12 col-md-6"}
        >
          <LabelField
            title={t("Phone number")}
            isMandatory={true}
            key="PhoneInput"
            htmlfor={field.name}
          />
          <div className="form-control field-shadow">
            <PhoneInputWithCountrySelect
              name={value.name}
              label={value.label}
              required={value.required}
              defaultCountry="BE"
              initialValueFormat="national"
              placeholder={t("Enter phone number")}
              onChange={handleChange}
              value={formData[value.name]}
              id={field.name}
            />
          </div>
          <div className="height-20" style={{ marginBottom: "0.5vw" }}>
            {errors[value.name] && (
              <span className="text-danger">{errors[value.name]}</span>
            )}
          </div>
        </div>
      );
    case "phone-number":
      return (
        <div
          className={value.className ? value.className : "col-sm-12 col-md-6"}
        >
          <LabelField
            title={t("Phone number")}
            isMandatory={true}
            key="PhoneInput"
            htmlfor={field.name}
          />
          <div className="form-control field-shadow">
            <PhoneInput
              name={value.name}
              label={value.label}
              required={value.required}
              defaultCountry="BE"
              international
              placeholder={t("Enter phone number")}
              onChange={handleChange}
              value={formData[value.name]}
              id={field.name}
            />
          </div>
          <div className="height-20" style={{ marginBottom: "0.5vw" }}>
            {errors[value.name] && (
              <span className="text-danger">{errors[value.name]}</span>
            )}
          </div>
        </div>
      );

    case "status":
      return (
        <div
          className={value.className ? value.className : "col-sm-12 col-md-6"}
        >
          <div className="col-sm-12 col-md-6">
            <LabelField
              title={t(value.label)}
              isMandatory={value.required}
              key="Status"
              htmlfor={field.name}
            />
            <div className="row">
              <div className="col-md-12">
                {field.value.options.map((statusValue: any) => (
                  <RadioField
                    key={statusValue.value}
                    name={value.name}
                    value={statusValue.value}
                    ischecked={
                      formData[value.name] === statusValue.value ? true : false
                    }
                    handleChange={handleChange}
                    label={statusValue.label}
                    className={statusValue.value === 1 ? "me-3" : ""}
                    id={field.name}
                  />
                ))}
              </div>
              <div className="height-20" style={{ marginBottom: "0.5vw" }}>
                {errors[value.name] && (
                  <span className="text-danger">{errors[value.name]}</span>
                )}
              </div>
            </div>
          </div>
        </div>
      );
    case "checkbox":
      return (
        <div
          className={`${
            value.className ? value.className : "col-sm-12 col-md-6 col-lg-3"
          }  hotlistWrapper`}
        >
          <CheckBoxField
            label={value.label}
            name={value.name}
            onChangeHandler={handleChange}
            value={formData[value.name]}
            isChecked={formData[value.name] === 1}
            id={field.name}
            lineHeight="1.5vw"
          />
        </div>
      );
    case "text-area":
      return (
        <div
          className={value.className ? value.className : "col-sm-12 col-md-6"}
        >
          <LabelWithTextAreaField
            label={t(value.label)}
            name={value.name}
            id={field.name}
            placeholder={t(value.placeholder)}
            handleChange={handleChange}
            isMandatory={value.required}
            value={formData[value.name] ?? ""}
            error={errors[value.name]}
            {...(value?.showForMiles
              ? {
                  isDisabled:
                    authUser.email !== "absolute-jobs-team@infanion.com",
                }
              : { isDisabled: value.isDisabled ?? false })}
          />
        </div>
      );

    case "auto-dropdown":
      return (
        <div
          className={value.className ? value.className : "col-sm-12 col-md-6 autoCompleteFunction"}
        >
          <AutoCompleteDropdown
            label={value.label}
            microService={value?.microservice}
            onChange={handleChange}
            value={formData[value.name]}
            modelKey={value.modelKey}
            columnName={value?.columnName}
            customFetch={true}
            name={value.name}
            shouldCreateNew={value?.shouldCreateNew ?? true}
            error={errors[value.name]}
            isMandatory={true}
            isDisabledStatus={0}
          />
        </div>
      );
    default:
      return null;
  }
};
